export const falsyBouncer = arr => {
  return arr.filter(Boolean)
}
